export class FacebookAuthResponse {
  constructor(response) {
    this.userID = response.userID;
    this.expiresIn = response.expiresIn;
    this.code = response.code;
  }

  isValid() {
    return !!this.code;
  }

  // Might have null
  getUserID() {
    return this.userID;
  }

  // Might have null
  getExpiresIn() {
    return this.expiresIn;
  }

  // Shouldn't be null if the auth is success
  getCode() {
    return this.code;
  }
}
